import { createUseStyles } from 'react-jss'

import { COLOR, Z_INDEX, MQ } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    position: 'relative',
    width: '100%',
    height: 200,
    [MQ.TABLET]: {
      height: 275,
    },
    [MQ.DESKTOP]: {
      height: 350,
    },
  },
  image: {
    height: '100%',
  },

  title: {
    color: COLOR.WHITE,
    position: 'absolute',
    zIndex: Z_INDEX.CONTENT,
    top: '50%',
    transform: 'translateY(-50%)',
    left: '50%',
    paddingRight: 15,
    [MQ.TABLET_LARGE]: {
      left: 'auto',
      right: 0,
      paddingRight: 45,
    },
    [MQ.DESKTOP]: {
      paddingRight: 55,
    },
    [`@media (min-width: 1600px)`]: {
      right: 'auto',
      left: '50%',
    },
  },
})
